import React from "react";
import { Link } from "react-router-dom";

class TopNav extends React.Component {
  render() {
    return (
      <div className="navbar-fixed">
        <nav className="orange darken-2">
          <div className="nav-wrapper">
            <Link to="/" className="brand-logo" style={{fontFamily:'Leckerli One'}}>
              DW
            </Link>
            <ul className="right hide-on-med-and-down">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About Me</Link>
              </li>
              <li>
                <Link to="/portfolio">Portfolio</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    );
  }
}

export default TopNav;
